import getTime from 'date-fns/getTime';

const formattableDateUnitDifferenceBetweenDates = (date1, date2) => {
  const date1MS = getTime(date1);
  const date2MS = getTime(date2);

  const numSecondsDifference = (date2MS - date1MS) / 1000;
  const absoluteNumSecondsDifference = Math.abs(numSecondsDifference);

  if (absoluteNumSecondsDifference <= 60) {
    return [Math.round(numSecondsDifference), 'second'];
  } if (absoluteNumSecondsDifference <= 60 * 60) {
    return [Math.round(numSecondsDifference / 60), 'minute'];
  } if (absoluteNumSecondsDifference <= 60 * 60 * 24) {
    return [Math.round(numSecondsDifference / 60 / 60), 'hour'];
  } if (absoluteNumSecondsDifference <= 60 * 60 * 24 * 30) {
    return [Math.round(numSecondsDifference / 60 / 60 / 24), 'day'];
  }
  return [Math.round(numSecondsDifference / 60 / 60 / 24 / 30.5), 'month'];
  
};

const formatRelativeDate = (date) => {
  const [numUnitsDifference, unit] = formattableDateUnitDifferenceBetweenDates(date, new Date());
  const pluralizedUnit = numUnitsDifference === 1 ? unit : `${unit}s`;

  if (numUnitsDifference === 0) {
    return 'just now';
  }

  if (numUnitsDifference >= 0) {
    return `${numUnitsDifference} ${pluralizedUnit} ago`;
  }

  const absNumDifference = Math.abs(numUnitsDifference);
  return `${absNumDifference} ${pluralizedUnit} from now`;
  
};
export default formatRelativeDate;
